/* 博客特色图：按原始宽高比自适应高度（无裁切、无留白） */
(function () {
  function fix(img) {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    img.style.setProperty('aspect-ratio', img.naturalWidth + ' / ' + img.naturalHeight, 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('max-height', 'none', 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    var blk = img.closest('.image-block');
    if (blk) blk.style.setProperty('height', 'auto', 'important');
  }
  function run() {
    document.querySelectorAll('.image-block[class*="__blog"] img, .blog-post-content img').forEach(function (img) {
      if (img.complete) fix(img);
      else img.addEventListener('load', function () { fix(img); }, { once: true });
    });
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
